/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown>, count: NonNullable<unknown> }} Prescription_Notice_Day_ShortInputs */

const en_us2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} has only ${i?.count} exercises: your equipment, level and refusals left nothing else to add.`)
};

const pt_br2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} tem só ${i?.count} exercícios: seu equipamento, nível e recusas não deixaram outro para acrescentar.`)
};

const es_419_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} tiene solo ${i?.count} ejercicios: tu equipo, tu nivel y tus rechazos no dejaron otro para agregar.`)
};

const pt_pt2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} tem só ${i?.count} exercícios: o teu equipamento, nível e recusas não deixaram outro para acrescentar.`)
};

const fr_fr2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} n'a que ${i?.count} exercices : ton équipement, ton niveau et tes refus n'ont rien laissé d'autre à ajouter.`)
};

const de_de2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} hat nur ${i?.count} Übungen: Deine Ausstattung, dein Niveau und deine Ablehnungen ließen nichts anderes zu.`)
};

const it_it2_prescription_notice_day_short = /** @type {(inputs: Prescription_Notice_Day_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ha solo ${i?.count} esercizi: la tua attrezzatura, il tuo livello e i tuoi rifiuti non hanno lasciato altro da aggiungere.`)
};

/**
* | output |
* | --- |
* | "{day} has only {count} exercises: your equipment, level and refusals left nothing else to add." |
*
* @param {Prescription_Notice_Day_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_day_short = /** @type {((inputs: Prescription_Notice_Day_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Day_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_day_short(inputs)
	if (locale === "es-419") return es_419_prescription_notice_day_short(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_day_short(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_day_short(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_day_short(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_day_short(inputs)
	return en_us2_prescription_notice_day_short(inputs)
});
export { prescription_notice_day_short as "prescription.notice.day_short" }